export const TOKEN_STATUS = {
  missing: {
    title: 'Link Incomplete',
    description: 'This link is missing required information. Please use the link from your email.',
  },
  invalid: {
    title: 'Invalid Link',
    description: 'This link is invalid or has already been used.',
  },
  expired: {
    title: 'Link Expired',
    description: 'This link has expired. Please request a new one.',
  },
};

export function tokenCodeToStatus(code) {
  if (code === 'TOKEN_MISSING') return 'missing';
  if (code === 'TOKEN_EXPIRED') return 'expired';
  return 'invalid';
}
